import React, { useState } from 'react';
import axios from 'axios';
import { buildApiUrl } from '../../config/api';

const ReplyModal = ({ message, onClose, onSuccess }) => {
    const [replyMessage, setReplyMessage] = useState('');
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');

    const handleSend = async () => {
        if (!replyMessage.trim()) {
            setError('Please enter a reply message');
            return;
        }

        try {
            setSending(true);
            setError('');
            
            const token = localStorage.getItem('token');
            await axios.post(
                buildApiUrl(`/contact/messages/${message.id}/reply`),
                { replyMessage },
                { headers: { Authorization: `Bearer ${token}`, 'x-auth-token': token } }
            );

            onSuccess();
            onClose();
        } catch (error) {
            console.error('Error sending reply:', error);
            setError(error.response?.data?.message || 'Failed to send reply');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content reply-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Reply to {message.name}</h2>
                    <button className="modal-close" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="original-message-preview">
                        <h4>Original Message:</h4>
                        <p className="original-text">{message.message}</p>
                    </div>

                    <div className="form-group">
                        <label htmlFor="reply">Your Reply:</label>
                        <textarea
                            id="reply"
                            rows="6"
                            value={replyMessage}
                            onChange={(e) => setReplyMessage(e.target.value)}
                            placeholder="Type your reply here..."
                            className="reply-textarea"
                        ></textarea>
                    </div>

                    {error && (
                        <div className="error-message">
                            <i className="fas fa-exclamation-circle"></i>
                            {error}
                        </div>
                    )}

                    <div className="reply-actions">
                        <button 
                            className="btn-secondary" 
                            onClick={onClose}
                            disabled={sending}
                        >
                            Cancel
                        </button>
                        <button 
                            className="btn-primary" 
                            onClick={handleSend}
                            disabled={sending}
                        >
                            {sending ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    Sending...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-paper-plane"></i>
                                    Send Reply
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReplyModal;
